<template>
  <container title='管理资产数排名' :loading='loading' :nodata='nodata' style='padding-bottom: 0;height: 266px;'>
    <div id='rankingOfAssets' style='height: 225px;'>

    </div>
  </container>
</template>

<script>
  import container from "../container";
  import {getManageAssetCountSort} from "../../../../../api/bigData";

  export default {
    name: "rankingOfAssets",
    components: {
      container,
    },
    data() {
      return {
        myChart: null,
        initData: [],
        loading:false,
        nodata:false,
      }
    },
    methods: {
      initEcharts() {
        var echarts = require('echarts');
        var myChart = echarts.init(document.getElementById('rankingOfAssets'));
        this.myChart = myChart
        let option = {
          dataZoom: [
            {
              type: 'slider',
              startValue: 1,
              endValue: 8,
              yAxisIndex: [0],
              show: this.initData.length<=8 ? false : true,
              borderColor: 'rgba(255,255,255,0)',
              backgroundColor: "rgba(255,255,255,0)",
              dataBackground: {
                lineStyle: {
                  color: 'rgba(255,255,255,0)',
                  width: '0',
                },
                areaStyle: {
                  color: 'rgba(255,255,255,0)',
                },
              },
              handleSize: "0",
              textStyle: {
                color: "rgba(255,255,255,0)"
              },
              right: "-24",
            },
            {
              type: 'inside',
              zoomOnMouseWheel: false,
              moveOnMouseWheel: true,
              yAxisIndex: [0],
              start: 1,
              end: this.initData.length<=8 ? 100 : 40
            }
          ],
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'shadow'
            }
          },
          grid: {
            top:20,
            left: 0,
            right: '4%',
            bottom: '3%',
            containLabel: true
          },
          xAxis: {
            type: 'value',
            splitLine: {
              show: true,
              lineStyle: {
                type: 'dashed',
                color: '#529DFF'
              }
            },
            axisLine: {
              lineStyle: {
                color: "#529DFF",
              },
            },
          },
          yAxis: {
            axisLine: {
              lineStyle: {
                color: "#529DFF",
              },
            },
            splitArea: {
              show: false
            },
            nameGap:8,
            splitNumber:8,
            axisTick: {
              show: false
            },
            axisLabel:{
              formatter:function (value, index) {
                if(value.length>5){
                  return value.substr(0,5)+'...'
                }else{
                  return value
                }
              }
            },
            type: 'category',
            data: this.initData.map((item) => {
              return item.companyName
            })
          },
          series: [
            {
              name: '2011年',
              type: 'bar',
              barWidth: 12,
              barGap: 9,
              itemStyle: {
                color: { //图形渐变颜色方法，四个数字分别代表，右，下，左，上，offset表示0%到100%
                  type: 'linear',
                  x: 0,
                  y: 0,
                  x2: 1, //从左到右 0-1
                  y2: 0,
                  colorStops: [{
                    offset: 0,
                    color: '#0256FF'
                  }, {
                    offset: 1,
                    color: '#02AAFD'
                  }],
                },
              },
              data: this.initData.map((item) => {
                return item.manageAssetCount
              })
            },
          ]
        };

        this.myChart.setOption(option)
        this.myChart.on('click', (params) => {
          let dataIndex=params.dataIndex
          let query = {companyId: this.initData[dataIndex].companyId,companyName:this.initData[dataIndex].companyName}
          this.$router.push({path: '/assetLeasing' ,query:query})
        })
      },
      init(){
        this.loading=true
        getManageAssetCountSort({}).then(res => {
          let data = res.data
          if (data.code === '000') {
            let initData=data.content
            initData.sort(function (a,b) {
                return a.manageAssetCount-b.manageAssetCount
            })
            this.initData=initData
            this.loading=false
            console.log(initData);
            this.$nextTick(function () {
              this.initEcharts()
            })
          } else {

          }
        }).catch(err => {
          console.log(err);
        }).finally(() => {
          this.loading=false
          this.nodata=!this.initData.length
        })
      },
    },
    created() {
      this.init()
    },
  }
</script>

<style scoped lang="scss">
  .rankingOfAssets {

  }
</style>
